import { Autocomplete, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

interface Props {
  value: string
  inputValue: string
  onInputChange: (value: string) => void
  onCommit: (value: string) => void
  suggestions?: string[]
  placeholder?: string
}

export function SearchInput({
  value,
  inputValue,
  onInputChange,
  onCommit,
  suggestions = [],
  placeholder = 'アイテム検索',
}: Props) {
  return (
    <Autocomplete
      freeSolo
      size="small"
      options={suggestions}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, next, reason) => {
        if (reason === 'input') {
          onInputChange(next)
        }
        if (reason === 'clear') {
          onInputChange('')
          onCommit('')
        }
        if (reason === 'reset') {
          onInputChange(next)
        }
      }}
      onChange={(_, next) => {
        if (typeof next === 'string') {
          onInputChange(next)
          onCommit(next)
        } else if (next === null) {
          onInputChange('')
          onCommit('')
        }
      }}
      noOptionsText="候補がありません"
      openOnFocus
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onCommit(inputValue)
            }
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      sx={{ bgcolor: 'background.paper', borderRadius: 1, minWidth: 200 }}
    />
  )
}
